// import lifecycle_stages from './lifecycle_stages'
import { variables } from "../config_variables/variables";

// const stages_on_or_after_final_claim = ['Final', 'Settlement', 'Advertised', 'Leased']
const  stages_on_or_after_final_claim = variables.lifecycle_stages.slice(variables.lifecycle_stages.indexOf('Settlement'))
console.log('variables.lifecycle_stages: ' + variables.lifecycle_stages)

const IsFinalCalledUp = (value) =>{
    return stages_on_or_after_final_claim.indexOf(value) > -1 ? true : false
 }

export default IsFinalCalledUp